import { renderElement } from "../../utils/use-render.js";
import { useDialogContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/dialog/backdrop.tsx
/** Presentational layer behind a dialog while it is rendered, including its exit transition. */
const DialogBackdrop = forwardRef(function DialogBackdrop({ render, className, style, ...elementProps }, forwardedRef) {
	const { state, stateAttrMap } = useDialogContext();
	if (!state.open) return null;
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef],
		props: [{
			role: "presentation",
			"aria-hidden": true
		}, elementProps]
	});
});
//#endregion
export { DialogBackdrop };

//# sourceMappingURL=backdrop.js.map